import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { eur } from "@/lib/api";
import { Card } from "@/components/common";

const ST = { inviato: "bg-sky-100 text-sky-800", accettato: "bg-emerald-100 text-emerald-800", perso: "bg-slate-200 text-slate-600" };

export default function QuoteHistory() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  const load = () => { api.get("/quotes").then((r) => setRows(r.data)); };
  useEffect(() => { load(); }, []);
  const setStatus = async (id, status) => { await api.patch(`/quotes/${id}`, { status }); load(); };
  const del = async (id) => { if (window.confirm("Eliminare questo preventivo?")) { await api.delete(`/quotes/${id}`); toast.success("Eliminato"); load(); } };
  if (!rows) return null;
  const count = (s) => rows.filter((r) => r.status === s).length;
  return (
    <Card className="p-4" data-testid="quote-history">
      <div className="flex flex-wrap gap-3 text-sm mb-3">
        <b>{rows.length} preventivi</b>
        <span className="text-sky-700">{count("inviato")} inviati</span>
        <span className="text-emerald-700">{count("accettato")} accettati</span>
        <span className="text-slate-500">{count("perso")} persi</span>
        {rows.length > 0 && <span className="text-slate-500">tasso di conversione {Math.round(count("accettato") / rows.length * 100)}%</span>}
      </div>
      {rows.length === 0 && <div className="text-sm text-slate-400 py-6 text-center" data-testid="quote-history-empty">Nessun preventivo salvato</div>}
      <div className="divide-y divide-slate-100">
        {rows.map((q) => (
          <div key={q.id} className="py-2" data-testid={`quote-row-${q.id}`}>
            <div className="flex flex-wrap items-center gap-2 text-sm">
              <span className="text-xs text-slate-400 w-20">{q.created_at?.slice(0, 10)}</span>
              <b className="text-slate-800">{q.client_name || "—"}</b>
              <span className="text-xs text-slate-500">{q.periodo_label} · {q.notti} notti · {q.adulti} ad.{q.bambini ? ` + ${q.bambini} bimbi` : ""} · {q.lingua.toUpperCase()}</span>
              <span className="font-semibold">{eur(q.totale_scontato ?? q.totale)}</span>
              <select data-testid={`quote-status-${q.id}`} value={q.status} onChange={(e) => setStatus(q.id, e.target.value)} className={`text-xs rounded px-2 py-1 font-semibold ${ST[q.status]}`}>
                <option value="inviato">inviato</option><option value="accettato">accettato</option><option value="perso">perso</option>
              </select>
              <div className="ml-auto flex gap-2 text-xs font-semibold">
                <button data-testid={`quote-view-${q.id}`} onClick={() => setOpen(open === q.id ? null : q.id)} className="text-sky-700">Testo</button>
                <button data-testid={`quote-to-option-${q.id}`} onClick={() => navigate(`/money?fromQuote=${q.id}`)} className="text-amber-700">Crea opzione</button>
                <button data-testid={`quote-delete-${q.id}`} onClick={() => del(q.id)} className="text-rose-600">Elimina</button>
              </div>
            </div>
            {open === q.id && <pre className="mt-2 text-xs whitespace-pre-wrap bg-slate-50 rounded p-3">{q.script}</pre>}
          </div>
        ))}
      </div>
    </Card>
  );
}
